import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import EditorPage from './pages/EditorPage';
import SVGsPage from './pages/SVGsPage';
import 'antd/dist/antd.css';

function App() {
  const { user, loading, logout } = useAuth();
  const [showRegister, setShowRegister] = useState(false);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg-primary)' }}>
        <div style={{ color: 'var(--text-secondary)' }}>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return showRegister ? (
      <Register onSwitchToLogin={() => setShowRegister(false)} />
    ) : (
      <Login onSwitchToRegister={() => setShowRegister(true)} />
    );
  }

  const antdTheme = {
    token: {
      colorBgBase: '#0f1117',
      colorBgContainer: '#181b23',
      colorBgElevated: '#1e2130',
      colorText: '#e8eaed',
      colorTextSecondary: '#9ba1ad',
      colorTextTertiary: '#6b7280',
      colorBorder: '#2d3148',
      colorBorderSecondary: '#2d3148',
      colorPrimary: '#00875a',
      colorSuccess: '#00875a',
      colorError: '#dc3545',
      colorWarning: '#f0ad4e',
      colorInfo: '#17a2b8',
      borderRadius: 6,
      borderRadiusLG: 10,
      borderRadiusSM: 6,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      fontSize: 13,
    },
    components: {
      Drawer: {
        colorBgElevated: '#181b23',
        colorText: '#e8eaed',
        colorTextHeading: '#e8eaed',
      },
      Menu: {
        colorBgContainer: '#181b23',
        colorText: '#e8eaed',
        itemHoverBg: '#2d3148',
        itemSelectedBg: '#2d3148',
        itemSelectedColor: '#e8eaed',
      },
      Button: {
        colorText: '#e8eaed',
        colorBgContainer: '#252838',
        colorBorder: '#2d3148',
        defaultHoverBg: '#2d3148',
        defaultHoverBorderColor: '#3d4256',
      },
      Input: {
        colorBgContainer: '#252838',
        colorText: '#e8eaed',
        colorBorder: '#2d3148',
        colorTextPlaceholder: '#6b7280',
        hoverBorderColor: '#3d4256',
        activeBorderColor: '#00875a',
      },
      Card: {
        colorBgContainer: '#1e2130',
        colorBorderSecondary: '#2d3148',
        colorTextHeading: '#e8eaed',
      },
      Modal: {
        contentBg: '#1e2130',
        headerBg: '#181b23',
        titleColor: '#e8eaed',
        colorText: '#e8eaed',
        colorTextHeading: '#e8eaed',
      },
      Form: {
        labelColor: '#9ba1ad',
      },
      Badge: {
        colorError: '#dc3545',
        colorSuccess: '#00875a',
      },
      Empty: {
        colorText: '#9ba1ad',
      },
      Alert: {
        colorErrorBg: 'rgba(220, 53, 69, 0.1)',
        colorErrorBorder: 'rgba(220, 53, 69, 0.3)',
        colorInfoBg: 'rgba(23, 162, 184, 0.1)',
        colorInfoBorder: 'rgba(23, 162, 184, 0.3)',
      },
    },
  };

  return (
    <ConfigProvider theme={antdTheme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/editor" replace />} />
          <Route path="/svgs" element={<SVGsPage user={user} onLogout={logout} />} />
          <Route path="/editor" element={<EditorPage user={user} onLogout={logout} />} />
          <Route path="/editor/:svgId" element={<EditorPage user={user} onLogout={logout} />} />
          <Route path="*" element={<Navigate to="/editor" replace />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
